import React from 'react';
import CampaignHeader from '../../../shared/CampaignHeader';
import CampaignProgressMeta from '../../../shared/CampaignHeader/components/CampaignProgressMeta';

/**
 * TableCampaignHeader Component
 * 
 * Uses the shared CampaignHeader component for breadcrumb, icon, and title.
 * Adds Table-specific progress bar with shine effect.
 */
const TableCampaignHeader = ({
  campaignName,
  campaignIcon,
  campaignProgress,
  breadcrumbPath = [],
  completedCount,
  totalCount,
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
  remainingBreakdown = [],
  onSelectSprint,
  onSprintIconChange,
  onRenameSprint,
}) => {
  if (!campaignName) return null;

  return (
    <CampaignHeader
      name={campaignName}
      icon={campaignIcon}
      breadcrumbPath={breadcrumbPath}
      onRename={onRenameSprint}
      onIconChange={onSprintIconChange}
      onSelectSprint={onSelectSprint}
      classPrefix="table-view__campaign-header"
    >
      {/* Table-specific progress bar with shine effect */}
      <div className="table-view__progress-row">
        <div className="table-view__progress-track">
          <div
            className="table-view__progress-fill"
            style={{ width: `${campaignProgress}%` }}
          >
            <div className="table-view__progress-shine" />
          </div>
          <div className="table-view__progress-glow" style={{ width: `${campaignProgress}%` }} />
        </div>
        <span className="table-view__progress-text">{campaignProgress}%</span>
      </div>
      
      {/* Task count meta */}
      <CampaignProgressMeta
        completedCount={completedCount}
        totalCount={totalCount}
        remainingMinutes={remainingMinutes}
        remainingMinMinutes={remainingMinMinutes}
        missingEstCount={missingEstCount}
        remainingBreakdown={remainingBreakdown}
        className="table-view__progress-meta"
        countClassName="table-view__progress-count"
      />
    </CampaignHeader>
  );
};

export default TableCampaignHeader;
